/*
 * ca-pdp-guard.js — pre-order block placement
 * ---------------------------------------------------------------------------
 * Scope note: relocating the stray quote / enquiry controls is handled by the
 * inline guard in sections/related-products-siblings.liquid. This file does
 * NOT touch those — two scripts moving the same nodes would fight. It owns one
 * job only.
 *
 * The pre-order app injects its block (lead time + Pre order button + reserve
 * copy) wherever it can reach in the info column, which leaves the CTA beside
 * the quantity stepper instead of below it, at a different width and radius
 * from Add to cart. That mismatch is what makes pre-order read as a separate,
 * less-trustworthy flow.
 *
 * This moves the block — as a whole, so any handler the app delegated from its
 * own container survives — to sit directly after the quantity / Add to cart
 * row. ca-pdp.css then gives the CTA exactly the Add to cart geometry.
 *
 * Nothing is hidden, nothing is cloned, no cart logic is reimplemented.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__CA_PDP_PREORDER_PLACER__) return;
  window.__CA_PDP_PREORDER_PLACER__ = true;

  var PREORDER = [
    '[class*="globo-preorder"]',
    '[class*="Globo-preorder"]',
    '[id*="globo-preorder"]',
    '.gpo-wrapper',
    '.gpo-container',
    '[class*="preorder-app"]'
  ].join(',');

  var HANDLED = 'data-ca-preorder-placed';
  var scheduled = false;

  function place() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    var anchor = info.querySelector('.qty-atc-row') ||
                 info.querySelector('.product-form');
    if (!anchor) return;

    var blocks = info.querySelectorAll(PREORDER);

    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (block.hasAttribute(HANDLED)) continue;

      /* Outermost wrapper only. */
      if (block.parentElement && block.parentElement.closest(PREORDER)) continue;

      /* Badges are pinned decoration, not the action. */
      var cls = (block.className || '').toString().toLowerCase();
      if (cls.indexOf('badge') !== -1 || cls.indexOf('ribbon') !== -1 || cls.indexOf('label') !== -1) {
        block.setAttribute(HANDLED, 'badge');
        continue;
      }

      /* Never swallow the anchor itself. */
      if (block === anchor || block.contains(anchor)) {
        block.setAttribute(HANDLED, 'skip');
        continue;
      }

      block.classList.add('ca-preorder-block');

      if (block.previousElementSibling === anchor) {
        block.setAttribute(HANDLED, 'inplace');
        continue;
      }

      try {
        anchor.insertAdjacentElement('afterend', block);
        block.setAttribute(HANDLED, 'moved');
      } catch (e) {
        /* app mid-render; the next tick picks it up */
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      place();
    }, 16);
  }

  function start() {
    place();
    /* The app can mount well after DOMContentLoaded. */
    setTimeout(place, 300);
    setTimeout(place, 1000);
    setTimeout(place, 2500);

    if (!('MutationObserver' in window)) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
